import { render } from "./navigation-search-box.vue?vue&type=template&id=834a0ab2&ts=true"
import script from "./navigation-search-box.vue?vue&type=script&lang=ts"
export * from "./navigation-search-box.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\agent\\_work\\44\\s\\DesignReg.VueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__